import React from 'react';
import { DailyWagIcon } from '../../../../icons/DailyWagIcon';
import { dailyWagLinkData } from '../../../../wag-react/components/site-navigation/urls';
import { Typography } from '../../../../wag-react/components/Typography';
import { Link } from '../../../../wag-react/core-components/link';
import { Flex } from '../../../../wag-react/next-components/Flex';
export const DailyWagLogoSection = () => <Link href={dailyWagLinkData.url} aria-label="daily-wag-logo-link" height="25px" hover data-sentry-element="Link" data-sentry-component="DailyWagLogoSection" data-sentry-source-file="index.tsx">
    <Flex flexDirection="column" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <DailyWagIcon data-sentry-element="DailyWagIcon" data-sentry-source-file="index.tsx" />
      <Flex flexDirection="row" lineHeight="1px" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Typography variant="body2" fontSize={['6px', '8px']} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          POWERED BY&nbsp;
        </Typography>
        <Typography variant="body2" fontSize={['6px', '8px']} color="wagGreen" fontWeight="600px" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          WAGWALKING.COM
        </Typography>
      </Flex>
    </Flex>
  </Link>;